var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65,
    fill: "none",
    stroke: "#000000",
    strokeOpacity: 0.886,
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(12 12) scale(1.22) translate(-10.3 -12.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9 6.1a3.7 3.7 0 0 0-5.04 4.62l-6.1 6.1a1.65 1.65 0 0 0 2.33 2.33l6.1-6.1a3.7 3.7 0 0 0 4.62-5.04l-2.27 2.27-1.78-.48-.48-1.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractors);
export default __webpack_public_path__ + "static/media/contractors.5e380b170d173e9a2019fd531eb2bfd2.svg";
export { ForwardRef as ReactComponent };